import { useEffect } from "react";

export const useAsyncEffect = (run, apply, deps) => {
    useEffect(() => {
        let valid = true;
        (async () => {
            const result = await run();
            if (valid) {
                apply(result);
            }
        })();
        return () => {
            valid = false;
        }
    }, deps);
}

export const useAsyncEffectWithCleanup = (callback, deps) => {
    useEffect(() => {
        let cleanup = null;
        async function run () {
            cleanup = await callback();
        }
        run();
        return () => cleanup?.();
    }, deps);
}